import React from 'react';

/**
 * Card Component - 2025 Design System (Notion-style)
 *
 * Production-grade card with:
 * - 12px border radius (modern, friendly)
 * - Subtle shadow with lift on hover
 * - Clean borders
 * - Smooth transitions
 */

export const Card = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`
        bg-white
        border border-gray-200
        rounded-xl
        shadow-sm
        hover:shadow-md
        hover:border-gray-300
        hover:-translate-y-0.5
        transition-all
        duration-200
        ease-out
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`px-6 py-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className = '', ...props }) => {
  return (
    <h3
      className={`text-lg font-semibold text-gray-900 ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
};

export const CardContent = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`px-6 py-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
